import React from 'react';
import Interno from './interno';
import {Error} from './error/Error';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useSignals } from '@preact/signals-react/runtime';

const Home = () => {
    useSignals();
    return (
        <BrowserRouter basename={`/${global.gConfig.basename}`}>
            {
                <div>
                    <Routes>
                        <Route path="/erro" exact element={<Error />} />
                        <Route path="*" element={<Interno />}  />
                    </Routes>                  
                </div>
            }
        </BrowserRouter>
    );
};

export default Home;
